import React from 'react';
import { Chip } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CloseIcon from '@mui/icons-material/Close';
import { Decision, DECISIONS } from '../../constants';

interface DecisionChipConfig {
  icon: React.ReactElement;
  backgroundColor: string;
  color: string;
  borderColor: string;
}

const DECISION_CHIP_CONFIG: Record<Decision, DecisionChipConfig> = {
  [DECISIONS.AWAITING_REVIEW]: {
    icon: <AccessTimeIcon sx={{ fontSize: 20 }} />,
    backgroundColor: '#EEEEEE',
    color: '#757575',
    borderColor: '#E0E0E0',
  },
  [DECISIONS.APPROVED]: {
    icon: <DoneAllIcon sx={{ fontSize: 20 }} />,
    backgroundColor: '#E8F5E9',
    color: '#43A047',
    borderColor: '#A5D6A7',
  },
  [DECISIONS.REQUESTED_ADDITIONAL_INFO]: {
    icon: <AccessTimeIcon sx={{ fontSize: 20 }} />,
    backgroundColor: '#E8EAF6',
    color: '#5C6BC0',
    borderColor: '#C5CAE9',
  },
  [DECISIONS.DECLINED]: {
    icon: <CloseIcon sx={{ fontSize: 20 }} />,
    backgroundColor: '#FEEBEE',
    color: '#F44336',
    borderColor: '#FECDD2',
  },
  [DECISIONS.PRE_APPROVED]: {
    icon: <DoneAllIcon sx={{ fontSize: 20 }} />,
    backgroundColor: '#E3F2FD',
    color: '#1565C0',
    borderColor: '#90CAF9',
  },
};

const DEFAULT_CONFIG: DecisionChipConfig = {
  icon: <AccessTimeIcon sx={{ fontSize: 20 }} />,
  backgroundColor: '#EEEEEE',
  color: '#757575',
  borderColor: '#E0E0E0',
};

interface Props {
  decision: string | null | undefined;
}

export const DecisionChip = ({ decision }: Props) => {
  const config = DECISION_CHIP_CONFIG[decision as Decision] ?? DEFAULT_CONFIG;
  const label = decision || DECISIONS.AWAITING_REVIEW;

  return (
    <Chip
      icon={config.icon}
      label={label}
      size="small"
      sx={{
        backgroundColor: config.backgroundColor,
        color: config.color,
        fontWeight: 500,
        fontSize: 14,
        border: `1px solid ${config.borderColor}`,
        borderRadius: '4px',
        '& .MuiChip-icon': { color: config.color },
      }}
    />
  );
};
